import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface ICancelBookingsService {
  bookingId: string;
  reason?: string;
}

const cancelBookingsService = async ({
  bookingId,
  reason,
}: ICancelBookingsService): Promise<void> => {
  await jhsfBookingsApi.post(`/bookings/${bookingId}/cancel`, { reason });
};

export default cancelBookingsService;
